import { apiCall } from '../actions/api-call';
import { Novel } from '../middlewares/novels';
import { Action } from '../actions';
import { GetManifestEventLogRequestAction, ManifestSingleActorRequestAction, getManifestEventLog, manifestSingleActor } from '../actions/manifest';
import ManifestService from '../../ports/ManifestService';

export interface ManifestNovels {
  getManifestEventLogNovel: Novel<GetManifestEventLogRequestAction, Action>;
  manifestSingleActorNovel: Novel<ManifestSingleActorRequestAction, Action>;
}

export const manifestNovelsCreator = (
  manifestService: ManifestService,
): ManifestNovels => {
  const getManifestEventLogNovel = async (
    { data }: GetManifestEventLogRequestAction,
    dispatch: (action: Action) => void,
  ) => {
    try {
      dispatch(apiCall());
      const log = await manifestService.getManifestEventLog(data);
      dispatch(apiCall.success());
      dispatch(getManifestEventLog.success(data, log));
    } catch (err) {
      dispatch(apiCall.failure(err.message));
      dispatch(getManifestEventLog.failure(err.message));
    }
  };

  const manifestSingleActorNovel = async (
    { data: { manifestId, actorName } }: ManifestSingleActorRequestAction,
    dispatch: (action: Action) => void,
  ) => {
    try {
      dispatch(apiCall());
      await manifestService.manifestSingleActor(manifestId, actorName);
      dispatch(apiCall.success());
      dispatch(manifestSingleActor.success());
    } catch (err) {
      dispatch(apiCall.failure(err.message));
      dispatch(manifestSingleActor.failure(err.message));
    }
  };

  return {
    getManifestEventLogNovel,
    manifestSingleActorNovel,
  };
};
